"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.masterDataReducer = void 0;
const master_data_component_1 = __importDefault(require("./master-data.component"));
const master_data_reducer_1 = __importDefault(require("./master-data.reducer"));
exports.masterDataReducer = master_data_reducer_1.default;
exports.default = master_data_component_1.default;
